import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

export default Vue.component(
  'flash-banner',
  {
    props: ['id', 'dismiss'],
    data () {
      let dismissed = false
      if (this.id) {
        try {
          const dismissedNotifications = window.localStorage.getItem('dismissed-notifications')
          dismissed = dismissedNotifications && dismissedNotifications.indexOf(`'${this.id}'`) >= 0
        } catch (error) {
          console.error('Failed to check if a notification is dismissed', error)
        }
      }
      return {
        dismissed
      }
    },
    methods: {
      dismissNotification: function () {
        this.dismissed = true
        if (this.id) {
          try {
            let dismissedNotifications = window.localStorage.getItem('dismissed-notifications') || ''
            dismissedNotifications = dismissedNotifications + `,'${this.id}'`
            window.localStorage.setItem('dismissed-notifications', dismissedNotifications)
          } catch (error) {
            console.error('Failed to record dismiss of notification locally', error)
          }
        }
        if (this.dismiss) {
          this.axios({
            method: 'POST',
            url: this.dismiss,
            maxRedirects: 0
          }).catch((error) => {
            console.error('Failed to record dismiss of notification remotely', error)
          })
        }
      }
    }
  }
)
